"use client";

import { useTranslation } from "react-i18next";
import { Icon } from "@iconify-icon/react";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface WorkspaceSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function WorkspaceSettingsDialog({ open, onOpenChange }: WorkspaceSettingsDialogProps) {
  const { t } = useTranslation(["workspaces", "common"]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="flex h-4/5 max-w-6xl flex-col">
        <DialogHeader>
          <DialogTitle className={"p-2 text-center"}>
            {t("workspaces:workspaceSettings")}
          </DialogTitle>
        </DialogHeader>
        <Tabs
          className="flex h-full w-full gap-4 border-t"
          defaultValue="invitations"
          orientation={"vertical"}
        >
          <TabsList className="flex h-full flex-col justify-start rounded-none border-r bg-background py-10 text-start">
            <TabsTrigger
              className="w-full justify-start gap-2 text-wrap text-start data-[state=active]:bg-muted data-[state=active]:shadow-none"
              value="manage-users"
            >
              <Icon icon={"mdi:user-edit"} />
              {t("workspaces:manageUsers")}
            </TabsTrigger>
          </TabsList>
          <TabsContent className="w-full focus-visible:ring-0" value="manage-users" />
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
